module.exports = __webpack_public_path__ + "img/afterPay_logo.4b060aa9.svg";